import React from 'react';
import ReleaseNotes from './pages/misc/ReleaseNotes';
import ReleaseNotesPopup from './components/ReleaseNotesPopup';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext'; // Adjust the import path as needed
import Sidebar from './components/Sidebar';
import TopMenu from './components/TopMenu';
import PrivateRoute from './components/PrivateRoute';
import MobileBottomMenu from './components/MobileBottomMenu';
import useIsMobile from './hooks/useIsMobile';
import { useAuth } from './context/AuthContext';
import Home from './pages/misc/Home.js';
import Register from './forms/Register';
import Login from './forms/Login';
import Newstudent from './pages/student/Newstudent.js';
import Editstudent from './pages/student/Editstudent';
import AllDocents from './pages/docent/AllDocents';
import NewDocent from './pages/docent/NewDocent.js';
import EditDocent from './pages/docent/EditDocent.js';
import ViewStudent from './pages/student/ViewStudent.js';
import ViewDocent from './pages/docent/ViewDocent.js';
import AllGroups from './pages/groep/AllGroups.js';
import NewGroup from './pages/groep/NewGroup.js';
import EditGroup from './pages/groep/EditGroup.js';
import AllStudents from './pages/student/AllStudents.js';
import NotFound from './pages/misc/NotFound.js';
import ForgotPassword from './pages/misc/ForgotPassword.js';
import NotAuthorized from './pages/misc/NotAuthorized.js';
import AllKlanten from './pages/klanten/AllKlanten.js';
import EditKlant from './pages/klanten/EditKlant.js';
import NewKlant from './pages/klanten/NewKlant.js';
import AllLocaties from './pages/locaties/AllLocaties.js';
import EditLocatie from './pages/locaties/EditLocatie.js';
import NewLocatie from './pages/locaties/NewLocatie.js';
import AllAbsences from './pages/absence/AllAbsence.js';
import EditAbsence from './pages/absence/EditAbsence.js';
import NewAbsence from './pages/absence/NewAbsence.js';
import ResetPassword from './pages/misc/ResetPassword.js';
import AllMessages from './pages/messages/AllMessages.js';
import ViewMessage from './pages/messages/ViewMessage.js';
import NewMessage from './pages/messages/NewMessage.js';
import MyProfile from './pages/users/MyProfile.js';
import AllParents from './pages/parents/AllParents.js';
import NewParent from './pages/parents/NewParent.js';
import EditParent from './pages/parents/EditParent.js';
import ViewParent from './pages/parents/ViewParent.js';
import Dashboard from './pages/misc/Dashboard.js';
import AllUsers from './pages/users/AllUsers.js';
import EditUser from './pages/users/EditUser.js';
import NewUser from './pages/users/NewUser.js';
import ViewUser from './pages/users/ViewUser.js';
import NewNote from './pages/notes/NewNote.js';
import EditNote from './pages/notes/EditNote.js';
import ViewNote from './pages/notes/ViewNote.js';
import AllNotes from './pages/notes/AllNotes.js';
import AllToetsen from './pages/toetsen/AllToetsen.js';
import ToetsForm from './pages/toetsen/ToetsForm.js';
import ListAllNotes from './pages/notes/ListAllNotes.js';
import CreateNoteGeneric from './pages/notes/CreateNoteGeneric.js';
import UserHours from './pages/hours/UserHours.js';
import AllTasks from './pages/taken/AllTasks.js';
import EditTask from './pages/taken/EditTask.js';
import NewTask from './pages/taken/NewTask.js';
import AdminHoursManagement from './pages/hours/AdminHoursManagement.js';
import HourReports from './pages/hours/HourReports.js';
import AllMeetingRounds from './pages/meeting/AllMeetingRounds.js';
import NewMeetingRound from './pages/meeting/NewMeetingRound.js';
import EditMeetingRound from './pages/meeting/EditMeetingRound.js';
import ParentMeetingBooking from './pages/meeting/ParentMeetingBooking.js';
import ParentPrivateLessonBooking from './pages/privateLessons/ParentPrivateLessonBooking.js';
import ReschedulePrivateLesson from './pages/privateLessons/ReschedulePrivateLesson.js';
import AllMyPrivateLessons from './pages/privateLessons/AllMyPrivateLessons.js';
import MyPrivateLessons from './pages/privateLessons/MyPrivateLessons.js';
import MyPrivateLessonAvailability from './pages/privateLessons/MyPrivateLessonAvailability.js';
import AllPrivateLessons from './pages/privateLessons/AllPrivateLessons.js';
import PrivateLessonTeacherLinks from './pages/privateLessons/PrivateLessonTeacherLinks.js';
import PrivateLessonsHome from './pages/privateLessons/PrivateLessonsHome.js';
import AdminPrivateLessonBooking from './pages/privateLessons/AdminPrivateLessonBooking.js';
import AllAnnouncements from './pages/announcements/AllAnnouncements.js';
import EditAnnouncement from './pages/announcements/EditAnnouncement.js';
import NewAnnouncement from './pages/announcements/NewAnnouncement.js';


function App() {
  const isMobile = useIsMobile();

  return (
    <AuthProvider>
      <AppContent isMobile={isMobile} />
    </AuthProvider>
  );
}


function AppContent({ isMobile }) {
  const { userInfo, loading } = useAuth();

  // Handle loading state
  if (loading) {
    return <div>Loading...</div>; // Or your custom loading component
  }

  // Safely get the role with fallback
  const userRole = userInfo?.role || '';



  return (
    // <AuthProvider>
    <>
      <TopMenu className="flex-shrink-0" />
      <ReleaseNotesPopup />
      <div className="d-flex flex-grow-1" style={{ paddingBottom: '80px' }}>
        {/* Verberg Sidebar op mobiel voor docent/ouder */}
        {/* {!(['docent', 'ouder'].includes(userRole) && isMobile) && ( */}
        {!isMobile && (<Sidebar />
        )}
        <BrowserRouter>
          <div className="flex-grow-1 p-4 overflow-auto">
            <Routes>
              <Route path="/release-notes" element={<PrivateRoute allowedRoles={['eigenaar']}><ReleaseNotes /></PrivateRoute>} />
              <Route path="*" element={<NotFound />} />
              <Route path='/' element={<Home />} />
              <Route path='/home' element={<Home />} />
              <Route path="/login" element={<Login />} />

              <Route path='/forgotpassword' element={<ForgotPassword />} />
              <Route path='/reset-password' element={<ResetPassword />} />
              <Route path="/notfound" element={<NotFound />} />
              <Route path="/notauthorized" element={<NotAuthorized />} />

              <Route path="/register" element={
                <PrivateRoute allowedRoles={["eigenaar"]}>
                  <Register />
                </PrivateRoute>
              } />

              <Route path="/myprofile" element={
                <PrivateRoute allowedRoles={["eigenaar", "super_admin", "locatie_admin", "docent", "leerling", "ouder"]}>
                  <MyProfile />
                </PrivateRoute>
              } />
              <Route path="/dashboard" element={
                <PrivateRoute allowedRoles={["eigenaar", "super_admin", "locatie_admin", "docent", "leerling", "ouder"]}>
                  <Dashboard />
                </PrivateRoute>
              } />
              <Route path="/allstudents" element={
                <PrivateRoute allowedRoles={["super_admin", "locatie_admin"]}>
                  <AllStudents />
                </PrivateRoute>
              } />
              <Route path="/docenten" element={
                <PrivateRoute allowedRoles={["super_admin", "locatie_admin"]}>
                  <AllDocents />
                </PrivateRoute>
              } />
              <Route path="/groups" element={
                <PrivateRoute allowedRoles={["super_admin", "locatie_admin", "docent"]}>
                  <AllGroups />
                </PrivateRoute>
              } />
              <Route path="/absences" element={
                <PrivateRoute allowedRoles={["super_admin", "locatie_admin", "docent", "leerling", "ouder"]}>
                  <AllAbsences />
                </PrivateRoute>
              } />
              <Route path="/editabsence/:id" element={
                <PrivateRoute allowedRoles={["super_admin", "locatie_admin", "docent", "leerling", "ouder"]}>
                  <EditAbsence />
                </PrivateRoute>
              } />
              <Route path="/newabsence" element={
                <PrivateRoute allowedRoles={["super_admin", "locatie_admin", "docent", "leerling", "ouder"]}>
                  <NewAbsence />
                </PrivateRoute>
              } />

              <Route path='/newstudent' element={
                <PrivateRoute allowedRoles={["super_admin", "locatie_admin"]}>
                  <Newstudent />
                </PrivateRoute>
              } />
              <Route path='/editstudent/:id' element={
                <PrivateRoute allowedRoles={["super_admin", "locatie_admin"]}>
                  <Editstudent />
                </PrivateRoute>
              } />

              <Route path="/ouders" element={
                <PrivateRoute allowedRoles={["super_admin", "locatie_admin"]}>
                  <AllParents />
                </PrivateRoute>
              } />

              <Route path="/ouder/nieuw" element={
                <PrivateRoute allowedRoles={["super_admin", "locatie_admin"]}>
                  <NewParent />
                </PrivateRoute>
              } />

              <Route path="/ouder/edit/:parentId" element={
                <PrivateRoute allowedRoles={["super_admin", "locatie_admin"]}>
                  <EditParent />
                </PrivateRoute>
              } />

              <Route path="/ouder/view/:id" element={
                <PrivateRoute allowedRoles={["super_admin", "locatie_admin"]}>
                  <ViewParent />
                </PrivateRoute>
              } />


              <Route path='/newdocent' element={
                <PrivateRoute allowedRoles={["super_admin", "locatie_admin"]}>
                  <NewDocent />
                </PrivateRoute>
              } />
              <Route path='/editdocent/:docentId' element={
                <PrivateRoute allowedRoles={["super_admin", "locatie_admin"]}>
                  <EditDocent />
                </PrivateRoute>
              } />
              <Route path='/viewstudent/:id' element={
                <PrivateRoute allowedRoles={["super_admin", "locatie_admin", "docent"]}>
                  <ViewStudent />
                </PrivateRoute>
              } />
              <Route path='/viewdocent/:id' element={
                <PrivateRoute allowedRoles={["super_admin", "locatie_admin"]}>
                  <ViewDocent />
                </PrivateRoute>
              } />
              <Route path="/newgroup" element={
                <PrivateRoute allowedRoles={["super_admin", "locatie_admin"]}>
                  <NewGroup />
                </PrivateRoute>
              } />
              <Route path="/editgroup/:id" element={
                <PrivateRoute allowedRoles={["super_admin", "locatie_admin"]}>
                  <EditGroup />
                </PrivateRoute>
              } />
              <Route path="/locaties" element={
                <PrivateRoute allowedRoles={["super_admin"]}>
                  <AllLocaties />
                </PrivateRoute>
              } />
              <Route path="/locatie/nieuw" element={
                <PrivateRoute allowedRoles={["super_admin"]}>
                  <NewLocatie />
                </PrivateRoute>
              } />
              <Route path="/locatie/edit/:id" element={
                <PrivateRoute allowedRoles={["super_admin"]}>
                  <EditLocatie />
                </PrivateRoute>
              } />
              <Route path="/klanten" element={
                <PrivateRoute allowedRoles={["eigenaar"]}>
                  <AllKlanten />
                </PrivateRoute>
              } />
              <Route path="/klant/edit/:id" element={
                <PrivateRoute allowedRoles={["eigenaar"]}>
                  <EditKlant />
                </PrivateRoute>
              } />
              <Route path="/klant/nieuw" element={
                <PrivateRoute allowedRoles={["eigenaar"]}>
                  <NewKlant />
                </PrivateRoute>
              } />
              <Route path='/messages/inbox' element={
                <PrivateRoute allowedRoles={["super_admin", "locatie_admin", "docent", "leerling", "ouder"]}>
                  <AllMessages key="inbox" type="inbox" />
                </PrivateRoute>

              } />
              <Route path='/viewmessage/:id' element={
                <PrivateRoute allowedRoles={["super_admin", "locatie_admin", "docent", "leerling", "ouder"]}>
                  <ViewMessage />
                </PrivateRoute>
              } />
              <Route path='/newmessage' element={
                <PrivateRoute allowedRoles={["super_admin", "locatie_admin", "docent", "leerling", "ouder"]}>
                  <NewMessage />
                </PrivateRoute>
              } />
              <Route path='/messages/sent' element={
                <PrivateRoute allowedRoles={["super_admin", "locatie_admin", "docent", "ouder"]}>
                  <AllMessages key="sent" type="sent" />
                </PrivateRoute>
              } />

              <Route path='/users' element={
                <PrivateRoute allowedRoles={["eigenaar", "super_admin", "locatie_admin"]}>
                  <AllUsers />
                </PrivateRoute>
              } />

              <Route path='/user/new' element={
                <PrivateRoute allowedRoles={["super_admin", "locatie_admin"]}>
                  <NewUser />
                </PrivateRoute>
              } />

              <Route path='/user/edit/:id' element={
                <PrivateRoute allowedRoles={["super_admin", "locatie_admin"]}>
                  <EditUser />
                </PrivateRoute>
              } />

              <Route path='/user/view/:id' element={
                <PrivateRoute allowedRoles={["eigenaar", "super_admin", "locatie_admin"]}>
                  <ViewUser />
                </PrivateRoute>
              } />

              <Route path="/toetsen" element={
                <PrivateRoute allowedRoles={["super_admin", "locatie_admin", "docent"]}><AllToetsen /></PrivateRoute>
              } />
              <Route path="/toetsen/nieuw" element={
                <PrivateRoute allowedRoles={["super_admin", "locatie_admin", "docent"]}><ToetsForm key="new" /></PrivateRoute>
              } />
              <Route path="/toetsen/:id/bewerken" element={
                <PrivateRoute allowedRoles={["super_admin", "locatie_admin", "docent"]}><ToetsForm key="edit" /></PrivateRoute>
              } />
              <Route path="/toetsen/:id" element={
                <PrivateRoute allowedRoles={["super_admin", "locatie_admin", "docent"]}><ToetsForm key="view" readOnly /></PrivateRoute>
              } />

              <Route path='/notes/:studentId' element={
                <PrivateRoute allowedRoles={["super_admin", "locatie_admin", "docent"]}>
                  <AllNotes />
                </PrivateRoute>
              } />

              <Route path='/notes/new/:studentId' element={
                <PrivateRoute allowedRoles={["super_admin", "locatie_admin", "docent"]}>
                  <NewNote />
                </PrivateRoute>
              } />

              <Route
                path='/notes/view/:noteId' element={
                  <PrivateRoute allowedRoles={["super_admin", "locatie_admin", "docent"]}>
                    <ViewNote />
                  </PrivateRoute>
                }
              />

              {/* Notitie bewerken */}
              <Route
                path='/notes/update/:noteId' element={
                  <PrivateRoute allowedRoles={["super_admin", "locatie_admin", "docent"]}>
                    <EditNote />
                  </PrivateRoute>
                }
              />
              <Route path='/notes/allnotes' element={
                <PrivateRoute allowedRoles={["super_admin", "locatie_admin", "docent"]}>
                  <ListAllNotes />
                </PrivateRoute>
              } />
              <Route path='/notes/create' element={
                <PrivateRoute allowedRoles={["super_admin", "locatie_admin", "docent"]}>
                  <CreateNoteGeneric />
                </PrivateRoute>
              } />

              <Route path="/userhours" element={
                <PrivateRoute allowedRoles={["super_admin", "locatie_admin", "docent"]}>
                  <UserHours />
                </PrivateRoute>
              } />

              <Route path="/adminhoursmanagement" element={
                <PrivateRoute allowedRoles={["super_admin", "locatie_admin"]}>
                  <AdminHoursManagement />
                </PrivateRoute>
              } />

              <Route path="/tasks" element={
                <PrivateRoute allowedRoles={["super_admin", "locatie_admin"]}>
                  <AllTasks />
                </PrivateRoute>
              } />

              <Route path="/tasks/edit/:id" element={
                <PrivateRoute allowedRoles={["super_admin", "locatie_admin"]}>
                  <EditTask />
                </PrivateRoute>
              } />
              <Route path="/tasks/new" element={
                <PrivateRoute allowedRoles={["super_admin", "locatie_admin"]}>
                  <NewTask />
                </PrivateRoute>
              } />

              <Route path="/hourreports" element={
                <PrivateRoute allowedRoles={["super_admin", "locatie_admin"]}>
                  <HourReports />
                </PrivateRoute>
              } />


              <Route path="/meeting-rounds" element={
                <PrivateRoute allowedRoles={["super_admin", "locatie_admin", "docent"]}>
                  <AllMeetingRounds />
                </PrivateRoute>
              } />
              <Route path="/meeting-rounds/new" element={
                <PrivateRoute allowedRoles={["super_admin", "locatie_admin", "docent"]}>
                  <NewMeetingRound />
                </PrivateRoute>
              } />
              <Route path="/meeting-rounds/edit/:id" element={
                <PrivateRoute allowedRoles={["super_admin", "locatie_admin", "docent"]}>
                  <EditMeetingRound />
                </PrivateRoute>
              } />
              <Route path="/oudergesprekken/inschrijven/:inviteId" element={
                <PrivateRoute allowedRoles={["ouder"]}>
                  <ParentMeetingBooking />
                </PrivateRoute>
              } />


              <Route path="/my-private-lessons" element={
                <PrivateRoute allowedRoles={["ouder"]}>
                  <AllMyPrivateLessons />
                </PrivateRoute>
              } />

              <Route path="/private-lessons/booking" element={
                <PrivateRoute allowedRoles={["ouder"]}>
                  <ParentPrivateLessonBooking />
                </PrivateRoute>
              } />

              <Route path="/private-lessons/reschedule/:id" element={
                <PrivateRoute allowedRoles={["ouder"]}>
                  <ReschedulePrivateLesson />
                </PrivateRoute>
              } />

              <Route path="/docent/private-lessons" element={
                <PrivateRoute allowedRoles={["docent"]}>
                  <MyPrivateLessons />
                </PrivateRoute>
              } />

              <Route path="/docent/private-lesson-availability" element={
                <PrivateRoute allowedRoles={["docent"]}>
                  <MyPrivateLessonAvailability />
                </PrivateRoute>
              } />

              <Route path="/private-lessons" element={
                <PrivateRoute allowedRoles={["super_admin", "locatie_admin", "docent"]}>
                  <AllPrivateLessons />
                </PrivateRoute>
              } />

              <Route path="/private-lessons-home" element={
                <PrivateRoute allowedRoles={["super_admin", "locatie_admin", "docent"]}>
                  <PrivateLessonsHome />
                </PrivateRoute>
              } />

              <Route path="/private-lesson-teacher-links" element={
                <PrivateRoute allowedRoles={["super_admin", "locatie_admin"]}>
                  <PrivateLessonTeacherLinks />
                </PrivateRoute>
              } />

              <Route path="/private-lesson-availability" element={
                <PrivateRoute allowedRoles={["super_admin", "locatie_admin"]}>
                  <MyPrivateLessonAvailability />
                </PrivateRoute>
              } />

              <Route path="/private-lessons/admin-booking" element={
                <PrivateRoute allowedRoles={["super_admin", "locatie_admin"]}>
                  <AdminPrivateLessonBooking />
                </PrivateRoute>
              } />

              <Route path="/announcements" element={
                <PrivateRoute allowedRoles={["super_admin", "locatie_admin"]}>
                  <AllAnnouncements />
                </PrivateRoute>
              } />
              <Route path="/newannouncement" element={
                <PrivateRoute allowedRoles={["super_admin", "locatie_admin"]}>
                  <NewAnnouncement />
                </PrivateRoute>
              } />
              <Route path="/editannouncement/:id" element={
                <PrivateRoute allowedRoles={["super_admin", "locatie_admin"]}>
                  <EditAnnouncement />
                </PrivateRoute>
              } />
              {/* Fallback route for unmatched paths */}


            </Routes>
          </div>
          {/* Vast mobiel ondermenu */}
          <MobileBottomMenu role={userRole} />
          {/* <MobileDrawerMenu /> */}
        </BrowserRouter>
      </div>
    </>
    // </AuthProvider>
  );
}

export default App;
